// extracted by mini-css-extract-plugin
export var active = "Testimonials-module--active--kWomN";
export var dot = "Testimonials-module--dot--ieUsN";
export var dots_container = "Testimonials-module--dots_container--Zp0wo";
export var image_container = "Testimonials-module--image_container--0-KFD";
export var page404Title = "Testimonials-module--page404-title--6VJKa";
export var testimoniaWrap = "Testimonials-module--testimoniaWrap--UN7Sh";
export var testimonial = "Testimonials-module--testimonial--B+iBH";
export var testimonial_logo = "Testimonials-module--testimonial_logo--ot5YS";
export var testimonials = "Testimonials-module--testimonials--kjoKv";
export var testimonials_container = "Testimonials-module--testimonials_container--S4vyr";